import { Injectable } from '@angular/core';
import { GlobalConstants } from '../../../../common/constants/global.constant';
import { AssetLibraryConstants } from '../asset-library/constants/asset-library.constant';
import { map } from 'rxjs/internal/operators/map';
import { HttpMethodsService } from '../_helpers/http-methods.service';
import { CreateSKUIdInfoRequest } from './sku-id-info.i';
import { ProfileAPI } from '../profile_api/constants/profile.constant';

@Injectable({
  providedIn: 'root'
})
export class SkuIdInfoService {
  skuIdList = [];
  segmentContentList = [];
  mainTileContentList = [];
  promoContentList = [];
  SKULIST_URL = AssetLibraryConstants.SLASH + GlobalConstants.ASSET_LIBRARY + AssetLibraryConstants.SLASH + GlobalConstants.SKUS;
  SKUCOMPARE_URL = AssetLibraryConstants.SLASH + GlobalConstants.ASSET_LIBRARY + AssetLibraryConstants.SLASH + GlobalConstants.SKUS + GlobalConstants.SLASH + GlobalConstants.COMPARE;
  userRole = sessionStorage.getItem(GlobalConstants.USER_ROLE);

  constructor(private httpMethodsservice: HttpMethodsService) { }

  setSKUIdList(data) {
    this.skuIdList = data;
  }

  setSegmentContentGroup(data) {
    this.segmentContentList = data;
  }

  setMainTileContentGroup(data) {
    this.mainTileContentList = data;
  }

  setPromoContentGroup(data) {
    this.promoContentList = data;
  }

  getAllSkuInfoByUSer(filterString?: string, retailerId?: string) {
    let url = this.userRole === GlobalConstants.SRT_ADMIN ? this.SKULIST_URL + ProfileAPI.RETAILER_ID + retailerId : this.SKULIST_URL;

    if (filterString && this.userRole === GlobalConstants.SRT_ADMIN) {
      url = `${url}${filterString}`;
    } else if (filterString) {
      url = `${url}${filterString}`;
    }
    return this.httpMethodsservice.get(url)
      .pipe(map((res: any) =>
        res));
  }

  // To do post call for upload sku csv.
  updateSkuCsv(skuCsvData: Object) {
    const url = this.SKULIST_URL + GlobalConstants.SLASH + GlobalConstants.UPLOAD;
    return this.httpMethodsservice.post(url, skuCsvData)
      .pipe(map((res: any) =>
        res
      ));
  }

  uploadImageToS3(id, file, type, folder) {
    const url = folder + AssetLibraryConstants.SLASH + id;
    return this.httpMethodsservice.putImage(url, file, type, true)
      .pipe(map((res: any) =>
        res));
  }

  deleteSKUIdContentById(skuId: string) {
    const url = this.SKULIST_URL
      + AssetLibraryConstants.SLASH + skuId;

    return this.httpMethodsservice.delete(url)
      .pipe(map((res: any) =>
        res));
  }


  deleteSKUIdContentByIds(skuIds) {
    const url = this.SKULIST_URL
      + AssetLibraryConstants.SLASH + GlobalConstants.DELETE_LOWER;

    return this.httpMethodsservice.post(url, skuIds)
      .pipe(map((res: any) =>
        res));
  }

  createSKUIdContent(payload: string, internalNameVal) {
    const url = this.SKULIST_URL;
    const addObject: CreateSKUIdInfoRequest = {
      internalName: internalNameVal,
      skuConfiguration: payload
    };

    return this.httpMethodsservice.post(url, addObject)
      .pipe(map((res: any) =>
        res));
  }

  updateSKUIdContent(payload, internalNameVal, skuId) {
    const url = this.SKULIST_URL
      + AssetLibraryConstants.SLASH + skuId;

    const addObject: CreateSKUIdInfoRequest = {
      internalName: internalNameVal,
      skuConfiguration: payload
    };

    return this.httpMethodsservice.patch(url, addObject)
      .pipe(map((res: any) =>
        res));
  }

  //Update Comparison changes
  updateCompareSKUData(data) {
    return this.httpMethodsservice.patch(this.SKUCOMPARE_URL, data)
      .pipe(map((res: any) =>
        res));
  }

  skuPostDownloadCsv(data, isDas?: boolean, isPricesupress?: boolean, customSrtEnabled?: boolean, retailerId?: string) {
    const url = this.userRole === GlobalConstants.SRT_ADMIN ? `${this.SKULIST_URL}${GlobalConstants.SLASH}${GlobalConstants.DOWNLAOD_ATTRIBUTE_NAME}${ProfileAPI.RETAILER_ID}${retailerId}${GlobalConstants.SRT_FLAG}` : `${this.SKULIST_URL}${GlobalConstants.SLASH}${GlobalConstants.DOWNLAOD_ATTRIBUTE_NAME}${GlobalConstants.IS_DAS}${isDas}${GlobalConstants.IS_PRICE_SUPRESS}${isPricesupress}${GlobalConstants.IS_CUSTOM_TILE}${customSrtEnabled}`
    return this.httpMethodsservice.postcsv(url, data)
      .pipe(map((res: any) =>
        res));
  }
}
